import { useRef } from "preact/hooks";
import { useNavigate, useLocation } from "react-router-dom";
import { parse, stringify } from "qs";
import { Localizer, Text } from "preact-i18n";
import { useHotkeys } from "react-hotkeys-hook";

import { Button, IconButton, InputAdornment, TextField } from "@mui/material";

import { useUserInfo } from "../../lib/useUserInfo";
import useIsGlobalSearch from "../../lib/useIsGlobalSearch";
import { Close } from "@mui/icons-material";

function composeURL(pathname, query) {
  if (!query) return pathname;

  return `${pathname}?${stringify({ q: query })}`;
}

const SearchBar = () => {
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const globalSearch = useIsGlobalSearch();

  const { q } = parse(search, { ignoreQueryPrefix: true });
  const { firstname } = useUserInfo();

  const inputRef = useRef();

  useHotkeys("ctrl+k, command+k", async (event) => {
    event.preventDefault();

    inputRef?.current.focus();
  });

  return (
    <Localizer>
      <TextField
        variant="outlined"
        fullWidth
        size="small"
        label={<Text id="SearchBar.label" />}
        placeholder={<Text id="SearchBar.placeholder" fields={{ firstname }} />}
        value={q}
        onChange={(event) => {
          return navigate(composeURL(pathname, event.target.value));
        }}
        InputLabelProps={{
          shrink: true,
        }}
        inputRef={inputRef}
        InputProps={
          !globalSearch && Boolean(q)
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => navigate(composeURL(pathname, ""))}
                    >
                      <Close />
                    </IconButton>
                    <Button
                      size="small"
                      onClick={() => {
                        const segments = pathname.split("/");
                        segments[segments.indexOf("dashboard") + 1] = "search";

                        return navigate(composeURL(segments.join("/"), q));
                      }}
                    >
                      <span class="md:block hidden">
                        <Text id="SearchBar.allMailboxes" />
                      </span>
                      <span class="md:hidden block">
                        <Text id="SearchBar.allMailboxesShort" />
                      </span>
                    </Button>
                  </InputAdornment>
                ),
              }
            : {}
        }
      />
    </Localizer>
  );
};

export default SearchBar;
